
export const listMutationsNames = {
	NAKLADOVE_STREDISKO_SELECT_MAPPER: 'NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
export const editMutationsNames = {
	NAKLADOVE_STREDISKO_SELECT_MAPPER: 'NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
